const FallBackUI = () => {
  return (
    <>
      <div className="flex items-center justify-center w-full h-full mx-auto">
        <div role="alert">
          <div className="px-4 py-2 text-3xl font-bold text-white bg-red-500 rounded-t">
            Oops...
          </div>
          <div className="px-4 py-3 text-xl text-red-700 bg-red-100 border border-t-0 border-red-400 rounded-b">
            <p>Something went wrong.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FallBackUI;
